import { useState } from 'react';
import InitFilters from './LoanProvider/constants/InitFiltering';
import { useCurrencyUnit } from 'hooks';
const useCustomHook = () => {
  const currencyText = useCurrencyUnit();
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [filters, setFilters] = useState(InitFilters(currencyText));
  const [selectedLoanId /* , setSelectedLoanId */] = useState(-1);
  const [openDialog, setOpenDialog] = useState(false);
  const [loan, setLoan] = useState(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [paymentWithCreditOpen, setPaymentWithCreditOpen] = useState(false);
  const [perSettlementOpen, setPerSettlementOpen] = useState(false);
  
  return {
    perSettlementOpen, setPerSettlementOpen,
    paymentWithCreditOpen, setPaymentWithCreditOpen,
    selectedInstallment, setSelectedInstallment,
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    loan,
    setLoan,
    filterParams,
    page, setPage,
    filters,
    setFilters,
    selectedLoanId,
    openDialog,
    setOpenDialog,
  };
};

export default useCustomHook;
